/**
 * Settings "Testing tools" self-service client (docs/specs/
 * settings-internal-testing-tools.md). Wraps the internal-account-gated
 * `/api/internal/dev-tools/*` endpoints — mirrors pipeline-transparency-
 * client.ts's structure. Both endpoints act only on the caller's own
 * account; there is no target-user parameter to send.
 */

import { request } from "./request";
import type { OnboardingResponse } from "@vardic/shared/types.ts";

export interface DevToolsDiagnostics {
  /** Backend git commit SHA (or "unknown" if unavailable). */
  gitSha: string;
  /** Backend NODE_ENV. */
  nodeEnv: string;
}

/**
 * Reset the caller's own onboarding to incomplete, so an internal tester can
 * re-run the onboarding flow without losing audits, credits, teams, or
 * billing history. `clearCompanyData: true` also nulls the previously-saved
 * company data so onboarding starts from a blank form.
 */
export async function resetOnboardingForTesting(
  clearCompanyData: boolean,
): Promise<OnboardingResponse> {
  return request<OnboardingResponse>("/internal/dev-tools/onboarding/reset", {
    method: "POST",
    body: { clearCompanyData },
    contentType: "json",
  });
}

/** Read-only backend build/environment context for bug reports. */
export async function getDevToolsDiagnostics(): Promise<DevToolsDiagnostics> {
  return request<DevToolsDiagnostics>("/internal/dev-tools/diagnostics");
}
